import axios from "axios";
let serverUrl = "";
// serverUrl = "http://localhost:3000";
serverUrl = "https://lobster-staging.herokuapp.com";

export const getShopMetafields = async () => {
	const shopMFs = await axios.get(`${serverUrl}/api/metafields/shop`);
	return shopMFs;
};
export const getCollectionMetafields = async (coll_handle) => {
	const collMFs = await axios.get(
		`${serverUrl}/api/metafields/collections?coll_handle=${coll_handle}`
	);
	return collMFs;
};
